import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SKIP_LANGUAGE } from '../http-context';

export const acceptLanguageInterceptor: HttpInterceptorFn = (request, next) => {
    if (request.context.get(SKIP_LANGUAGE)) {
        return next(request);
    }

    const translateService = inject(TranslateService);
    const language = translateService.getCurrentLang()?.slice(0, 2) ?? 'en';

    return next(
        request.clone({
            headers: request.headers.set('Accept-Language', language),
        }),
    );
};
